import config from 'config';
import HttpClient from 'utils/httpclient';
import BaseStore from 'stores/BaseStore';

class PathStore extends BaseStore {
  constructor () {
    super('paths', 'path', { site_model : true });
  }

  updatePathPagesRules = async (payload) => {
    const result =  await HttpClient.put(`${config.api}/pathpage/${payload.id}/rules`,payload, {params:{siteId: this.getCurrentSiteID()}});
    if (!result.data){
      throw Error()
    }
  }
}

export default new PathStore();
